import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { Dates, Title } from 'components/Misc/Typography';

const className = classnames(
	'py-2 px-3 flex flex-col space-y-2 border-4 rounded-lg cursor-pointer transition-all',
	'dark:border-neutral-800 dark:bg-neutral-800 hover:dark:bg-neutral-900',
	'border-white bg-white hover:bg-neutral-50'
);

const Course = ({ course }) => {
	return (
		<Link to={`/courses/${course.id}`} className={className}>
			<Title
				title={course.title}
				subtitle={course.subject.title}
				className="flex-1"
			/>

			<Dates
				startDate={course.startDate}
				endDate={course.endDate}
			/>
		</Link>
	);
};

export default Course;